<template lang="pug">
  .pdp-goes-with-color(v-if="colorKitName")
    p.xs-f-small.lg-f-medium.max-at-tweak Best match with {{ colorKitName }} hair color

</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "PdpGoesWithColor",

    computed: {
      ...mapState('pdp', ['product']),
      ...mapState('customer', ['cdata']),
      ...mapState('xsell', ['xsellForActiveColorKitSubs']),

      colorKitName() {
        if (!this.xsellForActiveColorKitSubs || !this.xsellForActiveColorKitSubs.length) {
          return null;
        }

        var subXsellWithProductInXsell = this.xsellForActiveColorKitSubs.find(subXsell => {
          if (!subXsell.xsell || !subXsell.xsell.length) {
            return false;
          }

          return subXsell.xsell.some(prod => prod.code == this.product.code);
        });

        if (subXsellWithProductInXsell) {
          return subXsellWithProductInXsell.subscription.productName;
        } else {
          return null;
        }
      }
    }
  };
</script>

<style scoped lang="stylus">
  .pdp-goes-with-color
    padding 0.75em 1em
    margin 0.5em 0
    width 100%
    background-color color-pale-blue
    border-radius 0.25em

</style>
